import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Divider, Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import FormItemProp from './FormItemProp';
import { FormContext } from '../../../cnr/contexts/FormContext';
import CountDropdown from '../elements/CountDropdown';

const FormElements = (props) => {

  // formContext
  const formContext = useContext(FormContext)
  const { form_state } = formContext ?? {}
  const { formKey, componentContexts, data_localForm, viewProps_normal, ignorePropSections, propSectionProps, noSort } = form_state ?? {}
  const { frameworkContext, viewSettingsComponentContext } = componentContexts ?? {}
  const { framework_state } = frameworkContext ?? {}
  const { fullMode } = framework_state ?? {}
  const settingsSort = viewSettingsComponentContext || noSort || fullMode ? true : true

  const [propElems, setPropElems] = useState()

  /**
   * Fills the _propElements with the _viewProps
   * @param {object} _propElements 
   * @param {object} _viewProps 
   */
  const ammendFormElements = (_propElements, _viewProps) => {
    if (_viewProps) {
      if (!_.isArray(_viewProps)) {
        if (settingsSort) {
          const _sorted = _.sortBy(_viewProps, '_position')
          _.forEach(_sorted, (sp, index) => {
            _propElements.push(<FormItemProp itemProp={sp} index={index} />)
          })
        } else {
          const sortedPropsP = _.orderBy(_viewProps, ['position'])
          sortedPropsP.forEach((itemProp, index) => {
            _propElements.push(<FormItemProp itemProp={itemProp} index={index} />)
          })
        }
      } else {
        _viewProps.forEach((itemProp, index) => {
          _propElements.push(<FormItemProp itemProp={itemProp} index={index} />)
        })
        const newJson = {}
        if (data_localForm) {
          _viewProps.forEach(vpKey => {
            newJson[vpKey] = data_localForm[vpKey]
          })
        }
      }
    } else {
      _propElements.push(<Segment basic key={uniqueKey('afip')}>{'No Item Props'}</Segment>)
    }
  }

  const form_elements = useMemo(() => {

    let propElements = [];

    if (propSectionProps && !ignorePropSections) {
      _.forEach(propSectionProps, (psp) => {
        const { section, items } = psp
        const { key: sectionKey, show } = section
        if (show) {
          propElements.push(<Divider key={uniqueKey('fi', 'd', sectionKey)} horizontal>{_.startCase(sectionKey)}</Divider>);
          ammendFormElements(propElements, items);
        }
      })
    } else {
      const _viewProps_normal = _.cloneDeep(viewProps_normal)
      ammendFormElements(propElements, _viewProps_normal);
    }

    return propElements
  }, [data_localForm, viewProps_normal, formKey]);

  useEffect(() => {
    setPropElems(form_elements)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [form_elements, formKey]);

  const content = () => {
    return propElems
  }

  return content()

}

export default FormElements